import { render, staticRenderFns } from "./menuitems.vue?vue&type=template&id=7bc9e13d"
import script from "./menuitems.vue?vue&type=script&lang=js"
export * from "./menuitems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports